import {makeStyles} from '@material-ui/core/styles'
import {reExportedColors, PaperCard} from '../../1elements'
import FormTextField from '../../2compounds/FormTextField'
import AssignOwner from './AssignOwner'
import {validateDescription, validateGroupName,} from '../../../services/util/editChecks'
import {useState} from 'react'

const GroupCreationFormCard1 = ({
    nameValue, onNameChange, descriptionValue, onDescriptionChange, owner, setOwner, showError, edit, nameOriginal
}) => {
    const classes = useStyles()
    const [groupNameHasError, setGroupNameHasError] = useState(false)

    validateGroupName(nameValue, edit, nameOriginal)
        .then((res)=>{
            console.log(res)
            setGroupNameHasError(res)
        })

    return (
        <PaperCard>
            <FormTextField label={'Name'}
                           value={nameValue}
                           onChange={onNameChange}
                           validation={showError&&groupNameHasError}
                           className={classes.textField}
                           required />
            <FormTextField label={'Description'}
                           value={descriptionValue}
                           onChange={onDescriptionChange}
                           validation={showError&&validateDescription(descriptionValue)}
                           rows={5}
                           className={classes.textField}/>
            <AssignOwner showError={showError} value={owner} setValue={setOwner} />
        </PaperCard>
    )
}

export default GroupCreationFormCard1

const useStyles = makeStyles({
    root: {},
    textField: {
        '& .MuiInputBase-input': {
            color: reExportedColors.TEXT, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
            fontFamily: "Roboto, sans-serif",
            fontSize: 13,
        }
    }
})